<template>
  <div class="demandReport" id="taskPlanContainer">
    <div class="leftDiv">
      <div class="leftTopDiv">
        <div class="userInfoClass">
          <div class="photo">
            <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" />
          </div>
          <div class="basicInfo">
            <tooltip-over
              :content="userInfo.username"
              :className="'username'"
              class="wid190"
              refName="username"
            ></tooltip-over>
            <div class="line"></div>
            <tooltip-over
              :content="'账号:' + userInfo.userNo"
              :className="'userNo'"
              class="wid190"
              refName="userNo"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.departmentName"
              :className="'departmentName'"
              class="wid190"
              refName="departmentName"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.roleName"
              :className="'roleName'"
              class="wid190"
              refName="roleName"
            ></tooltip-over>
          </div>
          <div class="logOut" @click="logOut()"></div>
        </div>
        <div class="statistics">
          <div class="newTask" :style="opacityInfos.opacityOfNewTask" @click="newTask">
            <div class="title">新任务</div>
            <div class="num">{{ numInfos.newTaskNum }}</div>
          </div>
          <div class="planning" :style="opacityInfos.opacityOfPlanning" @click="planning">
            <div class="title">规划中</div>
            <div class="num">{{ numInfos.planningNum }}</div>
          </div>
          <div
            class="submitted"
            :style="opacityInfos.opacityOfSubmitted"
            @click="submitted"
          >
            <div class="title">已提交</div>
            <div class="num">{{ numInfos.submittedNum }}</div>
          </div>
          <div class="rejected" :style="opacityInfos.opacityOfRejected" @click="rejected">
            <div class="title">驳回</div>
            <div class="num">{{ numInfos.rejectedNum }}</div>
          </div>
        </div>
      </div>
      <div class="leftBottomDiv">
        <div class="contentClass">
          <!-- <div class="title">任务总数</div> -->
          <div class="taskListCommonTableContainer">
            <el-table
              :data="taskList"
              @row-click="clickTaskRow"
              ref="taskList"
              height="384"
              style="width: 100%"
              class="taskPlanCommonTable"
              tooltip-effect="light"
              :row-class-name="taskRowClassName"
            >
              <el-table-column
                prop="local_id"
                label="任务编号"
                align="center"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="flight_name"
                label="计划名称"
                align="center"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="priority"
                label="优先级"
                align="center"
                min-width="50"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span class="prioritySpan" v-if="scope.row.priority === 1">低</span>
                  <span class="prioritySpan" v-else-if="scope.row.priority === 2"
                    >中</span
                  >
                  <span class="prioritySpan" v-else>高</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="flight_status"
                label="当前状态"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.flight_status === 10">规划中</span>
                  <span v-else-if="scope.row.flight_status === 15">已提交/待环境确认</span>
                  <span v-else-if="scope.row.flight_status === 20">待审批</span>
                  <span v-else-if="scope.row.flight_status === 30">环境保障驳回</span>
                  <span v-else-if="scope.row.flight_status === 31">审批拒绝</span>
                  <span v-else-if="scope.row.flight_status === 40">审批通过</span>
                  <span v-else-if="scope.row.flight_status === 50">待飞行</span>
                  <span v-else-if="scope.row.flight_status === 60">正在飞行</span>
                  <span v-else-if="scope.row.flight_status === 70">飞行结束</span>
                  <span v-else-if="scope.row.flight_status === 90">确认收货</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="searchArea">
            <div class="desc">任务搜索</div>
            <div class="separate"></div>
            <el-form :model="queryTaskForm" @submit.native.prevent>
              <el-form-item label="">
                <el-input
                  class="inputClass"
                  v-model="queryTaskForm.name"
                  @keyup.enter.native="queryTaskByCondition()"
                >
                  <i
                    class="el-icon-search-img"
                    slot="suffix"
                    @click="queryTaskByCondition()"
                  >
                  </i></el-input
              ></el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="taskPlanCenterDiv" v-if="planNeedDisplay">
      <div class="taskPlanCenterTopDiv">
        <div class="taskPlanFormTitle">
          <div class="leftTitle">
            <div class="localId">{{ taskPlanForm.local_id }}</div>
            <div class="planCodeName">计划编号</div>
            <div class="seperator">-</div>
            <div class="planName">计划名称:{{ taskPlanForm.flight_name }}&nbsp;</div>
          </div>
          <div class="rightPriority" v-show="currentProgress == 'planningProgress'">
            <img :src="minimum" class="minimum" @click="choosePriority(1)" />
            <div class="prioritySeperate"></div>
            <img :src="secondary" class="secondary" @click="choosePriority(2)" />
            <div class="prioritySeperate"></div>
            <img :src="highest" class="highest" @click="choosePriority(3)" />
          </div>

          <div
            class="rightPriority2"
            v-show="
              currentProgress == 'submittedProgress' ||
              currentProgress == 'rejectedProgress'
            "
          >
            <img :src="lowIconTPSrc" v-show="1 == taskPlanForm.priority" />
            <img :src="mediumIconSrc" v-show="2 == taskPlanForm.priority" />
            <img :src="highIconSrc" v-show="3 == taskPlanForm.priority" />
          </div>
        </div>

        <div class="seperate"></div>
        <div class="taskPlanCreateInfo">
          <div class="label">创建时间:</div>
          <div class="content">{{ taskPlanForm.created_at }}</div>
          <div class="label">提交账号:</div>
          <div class="content">{{ taskPlanForm.user_no }}</div>
        </div>
        <div class="seperate"></div>

        <div class="formTaskPlanDetailContainer">
          <el-form
            ref="taskPlanForm"
            :model="taskPlanForm"
            :rules="taskPlanFormRules"
            @submit.native.prevent
            class="taskPlanForm"
            label-width="80px"
            :disabled="currentProgress === 'rejectedProgress'"
          >
            <el-collapse v-model="activeAccordionName" accordion>
              <el-collapse-item name="deliveryTime">
                <template slot="title">
                  <i class="header-icon el-icon-delivery-time"></i>投送时间
                </template>
                <div class="taskPlanItemContainer taskPlanDeliveryTimeItemContainer">
                  <el-form-item class="leftHalfItem" prop="start_at" label="开始时间">
                    <el-date-picker
                      v-model="taskPlanForm.start_at"
                      type="datetime"
                      placeholder="请选择开始时间"
                      popper-class="datePickerClass"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      @change="startTimeChange"
                      :picker-options="deliveryStartTime"
                      :clearable="false"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item class="rightHalfItem" prop="end_at" label="结束时间">
                    <el-date-picker
                      v-model="taskPlanForm.end_at"
                      type="datetime"
                      placeholder="请选择结束时间"
                      popper-class="datePickerClass"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      @change="startEndTimeChange"
                      :picker-options="deliveryStartTime"
                      :clearable="false"
                    ></el-date-picker
                  ></el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item name="limitTime">
                <template slot="title">
                  <i class="header-icon el-icon-limit-time"></i>是否限时
                </template>
                <div class="taskPlanItemContainer">
                  <el-form-item
                    class="leftHalfItem percent40FormItem nonLabelFormItem"
                    prop="start_at"
                    label=""
                  >
                    <el-radio v-model="taskPlanForm.is_limit" :label="1">是</el-radio>
                    <el-radio
                      v-model="taskPlanForm.is_limit"
                      :label="0"
                      @change="cleanLimitTime"
                      >否</el-radio
                    >
                  </el-form-item>

                  <el-form-item
                    class="rightHalfItem percent60FormItem"
                    prop="limit_time"
                    label="到期时间"
                  >
                    <el-date-picker
                      v-model="taskPlanForm.limit_time"
                      type="datetime"
                      placeholder="请选择到期时间"
                      popper-class="datePickerClass"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      @change="setLimitTime"
                      :disabled="0 == taskPlanForm.is_limit"
                    ></el-date-picker
                  ></el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item name="insuredValue">
                <template slot="title">
                  <i class="header-icon el-icon-insured-value"></i>保价金额
                </template>
                <div class="taskPlanItemContainer">
                  <el-form-item class="noLabelFormItem" prop="f2" label="">
                    <el-input
                      class="insuredValueInput"
                      v-model="taskPlanForm.f2"
                      maxlength="9"
                      placeholder="请输入保价金额"
                      v-on:blur="selectInsuredValue"
                    ></el-input>
                    <div class="insuredValueSeparator">
                      <i class="el-icon-arrow-up" @click="addInsuredValue"></i>
                      <i class="el-icon-arrow-down" @click="reduceInsuredValue"></i>
                    </div>
                    <label class="insuredValueLabel">元</label>
                  </el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item name="goodsPlan">
                <template slot="title">
                  <i class="header-icon el-icon-goods-plan"></i>货物匹配
                </template>
                <div class="taskPlanItemContainer">
                  <el-form-item class="noLabelFormItem" prop="" label="">
                    <el-button @click="selectGoodsPlan">点击勾选货物</el-button>
                  </el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item name="linkPlanning">
                <template slot="title">
                  <i class="header-icon el-icon-link-planning"></i>链路规划
                </template>
                <div class="taskPlanItemContainer taskPlanLabelContainer">
                  <el-form-item class="leftHalfItem" prop="" label="链路型号:">
                    <label class="label-detail-info">{{
                      taskPlanForm.airLink.name
                    }}</label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="链路类型:">
                    <label class="label-detail-info">{{
                      taskPlanForm.airLink.typeName
                    }}</label>
                  </el-form-item>

                  <el-form-item
                    class="leftHalfItem lastFormItemRow"
                    prop=""
                    label="链路频点:"
                  >
                    <label class="label-detail-info">{{
                      taskPlanForm.airLink.frequency
                    }}</label>
                  </el-form-item>
                  <el-form-item
                    class="rightHalfItem lastFormItemRow"
                    prop=""
                    label="通讯站:"
                  >
                    <label class="label-detail-info">{{
                      taskPlanForm.airLink.com_station_name
                    }}</label>
                  </el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item :name="designatedPersonnel">
                <template slot="title">
                  <i class="header-icon el-icon-designated-personnel"></i>指派人员
                </template>
                <div class="taskPlanItemContainer taskPlanLabelContainer">
                  <el-form-item class="leftHalfItem" prop="" label="发货地勤:">
                    <label class="label-detail-info">
                      <el-tooltip
                        class="item"
                        effect="light"
                        v-if="taskPlanForm.userName1"
                        :content="taskPlanForm.userName1"
                        placement="top"
                        :disabled="taskPlanForm.userName1.length <= 10"
                      >
                        <span> {{ taskPlanForm.userName1.length > 10 ?  taskPlanForm.userName1.slice(0, 10) + '...' : taskPlanForm.userName1}} </span>
                      </el-tooltip>
                  </label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="保障员:">
                    <label class="label-detail-info">
                      <el-tooltip
                        class="item"
                        effect="light"
                        v-if="taskPlanForm.userName3"
                        :content="taskPlanForm.userName3"
                        placement="top"
                        :disabled="taskPlanForm.userName3.length <= 10"
                      >
                        <span> {{ taskPlanForm.userName3.length > 10 ?  taskPlanForm.userName3.slice(0, 10) + '...' : taskPlanForm.userName3}} </span>
                      </el-tooltip>
                    </label>
                  </el-form-item>

                  <el-form-item class="leftHalfItem" prop="" label="收货地勤:">
                    <label class="label-detail-info">
                      <el-tooltip
                        class="item"
                        effect="light"
                        v-if="taskPlanForm.userName2"
                        :content="taskPlanForm.userName2"
                        placement="top"
                        :disabled="taskPlanForm.userName2.length <= 10"
                      >
                        <span> {{ taskPlanForm.userName2.length > 10 ?  taskPlanForm.userName2.slice(0, 10) + '...' : taskPlanForm.userName2}} </span>
                      </el-tooltip>
                      </label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="审核员:">
                    <label class="label-detail-info">
                       <el-tooltip
                        class="item"
                        effect="light"
                        v-if="taskPlanForm.userName6"
                        :content="taskPlanForm.userName6"
                        placement="top"
                        :disabled="taskPlanForm.userName6.length <= 10"
                      >
                        <span> {{ taskPlanForm.userName6.length > 10 ?  taskPlanForm.userName6.slice(0, 10) + '...' : taskPlanForm.userName6}} </span>
                      </el-tooltip>
                      </label>
                  </el-form-item>
                  <el-form-item
                    class="leftHalfItem lastFormItemRow"
                    prop=""
                    label="任务控制:"
                  >
                    <label class="label-detail-info">
                       <el-tooltip
                        class="item"
                        effect="light"
                        v-if="taskPlanForm.userName4"
                        :content="taskPlanForm.userName4"
                        placement="top"
                        :disabled="taskPlanForm.userName4.length <= 10"
                      >
                        <span> {{ taskPlanForm.userName4.length > 10 ?  taskPlanForm.userName4.slice(0, 10) + '...' : taskPlanForm.userName4}} </span>
                      </el-tooltip>
                      </label>
                  </el-form-item>
                  <el-form-item
                    class="rightHalfItem lastFormItemRow"
                    prop=""
                    label="飞手:"
                  >
                    <label class="label-detail-info">{{ taskPlanForm.userName5 }}</label>
                  </el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item name="taskplanPoint">
                <template slot="title">
                  <i class="header-icon el-icon-taskplan-point"></i>驻点选择
                </template>
                <div class="taskPlanItemContainer taskPlanLabelContainer">
                  <el-form-item class="leftHalfItem" prop="" label="起点名称:">
                    <label class="label-detail-info">{{
                      taskPlanForm.starstaypoint.name
                    }}</label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="起点高度:">
                    <label class="label-detail-info">{{
                      taskPlanForm.starstaypoint.altitude
                    }}</label>
                  </el-form-item>

                  <el-form-item class="leftHalfItem" prop="" label="起点经度:">
                    <label class="label-detail-info">{{
                      taskPlanForm.starstaypoint.longitude
                    }}</label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="起点纬度:">
                    <label class="label-detail-info">{{
                      taskPlanForm.starstaypoint.latitude
                    }}</label>
                  </el-form-item>

                  <el-form-item class="leftHalfItem" prop="" label="终点名称:">
                    <label class="label-detail-info">{{
                      taskPlanForm.endstaypoint.name
                    }}</label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="终点高度:">
                    <label class="label-detail-info">{{
                      taskPlanForm.endstaypoint.altitude
                    }}</label>
                  </el-form-item>

                  <el-form-item
                    class="leftHalfItem lastFormItemRow"
                    prop=""
                    label="终点经度:"
                  >
                    <label class="label-detail-info">{{
                      taskPlanForm.endstaypoint.longitude
                    }}</label>
                  </el-form-item>
                  <el-form-item
                    class="rightHalfItem lastFormItemRow"
                    prop=""
                    label="终点纬度:"
                  >
                    <label class="label-detail-info">{{
                      taskPlanForm.endstaypoint.latitude
                    }}</label>
                  </el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item name="routePlanning">
                <template slot="title">
                  <i class="header-icon el-icon-route-planning"></i>航路规划
                </template>
                <div class="taskPlanItemContainer taskPlanLabelContainer">
                  <el-form-item class="leftHalfItem" prop="" label="编号:">
                    <label class="label-detail-info">{{
                      taskPlanForm.airline_name
                    }}</label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="航向长度:">
                    <label class="label-detail-info"
                      >{{ taskPlanForm.total_mileage }}km</label
                    >
                  </el-form-item>

                  <el-form-item
                    class="leftHalfItem lastFormItemRow"
                    prop=""
                    label="飞行高度:"
                  >
                    <label class="label-detail-info"
                      >{{ taskPlanForm.average_altiude }}m</label
                    >
                  </el-form-item>
                  <el-form-item
                    class="rightHalfItem lastFormItemRow"
                    prop=""
                    label="航点数:"
                  >
                    <label class="label-detail-info">{{
                      taskPlanForm.point_count
                    }}</label>
                  </el-form-item>
                </div> </el-collapse-item
              ><el-collapse-item :name="uavSelect">
                <template slot="title">
                  <i class="header-icon el-icon-uav-select"></i>无人机选择
                </template>
                <div class="taskPlanItemContainer taskPlanLabelContainer">
                  <el-form-item class="leftHalfItem" prop="" label="飞机名称:">
                    <label class="label-detail-info">
                      <el-tooltip
                        class="item"
                        effect="light"
                        v-if="taskPlanForm.uav.name"
                        :content="taskPlanForm.uav.name"
                        placement="top"
                        :disabled="taskPlanForm.uav.name.length <= 10"
                      >
                        <span> {{ taskPlanForm.uav.name.length > 10 ?  taskPlanForm.uav.name.slice(0, 10) + '...' : taskPlanForm.uav.name}} </span>
                      </el-tooltip>
                      </label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="最大载重:">
                    <label class="label-detail-info">{{
                      taskPlanForm.uav.max_payload
                    }}</label>
                  </el-form-item>

                  <el-form-item class="leftHalfItem" prop="" label="货舱体积:">
                    <label class="label-detail-info">{{
                      taskPlanForm.uav.cargo_hold_volume
                    }}</label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="满载航时:">
                    <label class="label-detail-info">{{
                      taskPlanForm.uav.max_fly_time
                    }}</label>
                  </el-form-item>

                  <el-form-item class="leftHalfItem" prop="" label="机载通讯:">
                    <label class="label-detail-info">{{
                      taskPlanForm.uav.airborne_communication_name
                    }}</label>
                  </el-form-item>
                  <el-form-item class="rightHalfItem" prop="" label="生产厂商:">
                    <label class="label-detail-info">
                       <el-tooltip
                          class="item"
                          effect="light"
                          v-if="taskPlanForm.uav.company_name"
                          :content="taskPlanForm.uav.company_name"
                          placement="top"
                          :disabled="taskPlanForm.uav.company_name.length <= 10"
                        >
                          <span> {{ taskPlanForm.uav.company_name.length > 10 ?  taskPlanForm.uav.company_name.slice(0, 10) + '...' : taskPlanForm.uav.company_name}} </span>
                        </el-tooltip>
                      </label>
                  </el-form-item>

                  <el-form-item
                    class="leftHalfItem"
                    prop=""
                    label-width="8px"
                    style="margin-top: 13px"
                  >
                    <el-checkbox
                      v-model="taskPlanForm.is_target"
                      class="taskPlan-checkbox"
                      :true-label="1"
                      :false-label="0"
                      @change="changeParkingApron"
                      >是否需要降落引导目标</el-checkbox
                    >
                    <!-- @change="changeParkingApron" -->
                  </el-form-item>

                  <el-form-item
                    class="leftHalfItem lastFormItemRow"
                    prop=""
                    label-width="8px"
                    style="width: 100%; height: 70px; margin-top: 7px"
                    v-show="1 == taskPlanForm.is_target"
                  >
                    <img
                      class="parkingApronImg"
                      :src="
                        1 == taskPlanForm.target_icon ? parkingApron1Hover : parkingApron1
                      "
                      @click="selectParkingApron(1)"
                    /><img
                      class="parkingApronImg"
                      :src="
                        2 == taskPlanForm.target_icon ? parkingApron2Hover : parkingApron2
                      "
                      @click="selectParkingApron(2)"
                    />
                  </el-form-item>
                </div>
              </el-collapse-item>
              <el-collapse-item name="planCirculationInfo">
                <template slot="title">
                  <i class="header-icon el-icon-plan-cir-info"></i>计划流转信息
                </template>
              </el-collapse-item>
              <el-collapse-item
                name="noteTaskPlan"
                v-show="currentProgress != 'rejectedProgress'"
              >
                <template slot="title">
                  <i class="header-icon el-icon-note"></i>备注
                </template>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </div>
      </div>
      <div class="centerBottomDiv">
        <el-button
          class="blueButton"
          @click="cancelClick"
          v-show="currentProgress != 'newTaskProgress'"
        >
          取消</el-button
        >
        <el-button
          class="deleteButton"
          v-if="
            null !== delPermission &&
            currentProgress != 'newTaskProgress' &&
            1 != taskPlanForm.deleteBtnShow
          "
          @click="delTaskPlan"
        >
          {{ delPermission.name }}
        </el-button>
      </div>
    </div>
    <div class="rightDiv taskPlanRightMainContainer" v-show="planNeedDisplay">
      <div
        class="rightTopDiv"
        v-show="
          currentProgress == 'planningProgress' || currentProgress == 'submittedProgress'
        "
      >
        <div
          v-show="deliveryTimeShow"
          class="rightMainContainer rightDeliveryTimeContainer"
        >
          <div class="rightCommonTitle">
            <div class="title">投送时间</div>
            <div class="separator"></div>
          </div>

          <div class="deliveryTimeContent">
            <div class="infoRow">
              <label class="title">开始时间 ：</label>
              <label class="content">{{ taskPlanForm.start_at }}</label>
            </div>
            <div class="infoRow">
              <label class="title">结束时间 ：</label>
              <label class="content">{{ taskPlanForm.end_at }}</label>
            </div>
          </div>
        </div>

        <div v-show="goodsPlanShow" class="rightMainContainer rightGoodsPlanContainer">
          <div class="rightCommonTitle">
            <div class="title">货物匹配</div>
            <div class="separator"></div>
          </div>

          <div class="taskPlanGoodsStatContainer">
            <img :src="goodsNumIcon" /><label class="title">件数:&nbsp;</label
            ><label class="content countContent">{{ goodsCount }}</label>
            <img :src="goodsWeightIcon" /><label class="title">总重量:&nbsp;</label
            ><label class="content">{{ goodsWeight }}KG</label>
          </div>

          <div class="taskPlanCommonTableContainer">
            <div class="taskPlanCommonTableHeader">
              <label>货物列表</label>
            </div>
            <el-table
              :data="goodsTableData"
              class="taskPlanCommonTable"
              @row-click="clickGoodsRow"
              style="width: 100%"
              height="440"
              ref="commonTable"
              tooltip-effect="light"
            >
              <el-table-column :show-overflow-tooltip="true" width="80" label="匹配货物">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="taskPlanForm.selectGoodsIds"
                    :label="scope.row.id"
                    class="goodsCheckBox"
                    style="pointer-events: none"
                  ></el-checkbox>
                </template> </el-table-column
              ><el-table-column
                :show-overflow-tooltip="true"
                prop="local_id"
                label="货物编号"
                width="240"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="goods_name"
                label=""
                width="130"
              >
                <template slot="header"
                  ><label>尺寸/厘米</label><i class="right el-icon-arrow-down"></i>
                </template>
                <template slot-scope="scope">
                  {{
                    scope.row.goods_length +
                    "*" +
                    scope.row.goods_width +
                    "*" +
                    scope.row.goods_height
                  }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="address"
                label=""
                width="130"
              >
                <template slot="header"
                  ><label>重量/KG</label><i class="right el-icon-arrow-down"></i>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.goods_weight }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="id"
                label="属性"
                width="320"
              >
                <template slot="header"
                  ><i class="left el-icon-square"></i><label>属性</label>
                </template>
                <template slot-scope="scope">
                  <el-checkbox
                    :checked="scope.row.goods_attribute_id === 1"
                    class="attributeCheckbox"
                    disabled
                    >易碎性</el-checkbox
                  >
                  <el-checkbox
                    :checked="scope.row.goods_explosible_id === 1"
                    class="attributeCheckbox"
                    disabled
                    >易爆性</el-checkbox
                  >
                  <el-checkbox
                    :checked="scope.row.goods_inflammable_id === 1"
                    class="attributeCheckbox"
                    disabled
                    >易燃性</el-checkbox
                  >
                  <el-checkbox
                    :checked="scope.row.goods_cautery_id === 1"
                    class="attributeCheckbox"
                    disabled
                    >腐蚀性</el-checkbox
                  >
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="goods_type_name"
                label="类型"
                width="100"
              >
              </el-table-column
              ><el-table-column
                :show-overflow-tooltip="true"
                prop="goods_package_name"
                label="包装"
                width="100"
              >
              </el-table-column
              ><el-table-column
                prop="goods_secrecy_id"
                label="密级"
                width="100"
                :formatter="formatterSecret"
              >
              </el-table-column>
            </el-table>
          </div>

          <div class="bottomSeparator"></div>
          <div class="selectGoodsInfoContainer">
            <label>匹配货物数:</label>
            <label style="width: 50px">{{ taskPlanForm.goodsCount }}</label>
            <label>总重量</label>
            <label>{{ taskPlanForm.goodsWeight }}KG</label>
          </div>
          <el-button class="rightCommonButton" @click="selectGoodsPlan(true)"
            >确定</el-button
          >
        </div>

        <div v-show="linkPlanningShow" class="rightMainContainer rightLimitTimeContainer">
          <div class="rightCommonTitle">
            <div class="title">链路规划</div>
            <div class="separator"></div>
          </div>

          <div class="taskPlanCommonTableContainer">
            <el-table
              :data="airLinkTableData"
              class="taskPlanCommonTable"
              @row-click="clickAirLinkRow"
              style="width: 100%"
              height="478"
              ref="commonTable"
              tooltip-effect="light"
              :row-class-name="linkPlanningRowClassName"
            >
              <el-table-column :show-overflow-tooltip="true" width="46">
                <template slot-scope="scope">
                  <el-radio v-model="taskPlanForm.link_id" :label="scope.row.id"
                    >&nbsp;</el-radio
                  >
                </template> </el-table-column
              ><el-table-column
                :show-overflow-tooltip="true"
                prop="name"
                label="名称"
                width="100"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="code"
                label="编号"
                width="119"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="type"
                label="类型"
                width="137"
                :formatter="formatterLinkType"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="frequency"
                label="频点"
                width="137"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="com_station_name"
                label="通讯站"
                width="134"
              >
              </el-table-column>
            </el-table>
          </div>

          <div class="bottomSeparator"></div>

          <el-button class="rightCommonButton" @click="selectLinkPlanning"
            >确定</el-button
          >
        </div>

        <div
          v-show="designatedPersonnelShow"
          class="rightMainContainer rightDesignatedPersonnelContainer"
        >
          <div class="rightCommonTitle">
            <div class="title">指派人员</div>
            <div class="separator"></div>
          </div>

          <el-form
            :rules="personFormRules"
            ref="personForm"
            :model="personForm"
            label-width="120px"
            @submit.native.prevent
            class="taskPlanCommonForm"
          >
            <div class="taskPlanCommonFormRow">
              <label class="rowTitle">发货地勤</label>
              <el-form-item
                label="姓名"
                prop="customer_groundstaf_id"
                label-width="100px"
              >
                <el-select
                  v-model="personForm.customer_groundstaf_id"
                  placeholder="请选择姓名"
                  popper-class="selectPopperClass"
                  @visible-change="checkCanSelect1"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="user in users1"
                    :key="user.id"
                    :label="user.username"
                    :value="user.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" prop="longitude" label-width="100px">
                <el-select
                  v-model="personForm.department_id1"
                  placeholder="请选择部门"
                  popper-class="selectPopperClass"
                  @change="changeDepartment1"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.id"
                    :label="department.name"
                    :value="department.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="taskPlanCommonFormRow">
              <label class="rowTitle">收货地勤</label>
              <el-form-item label="姓名" prop="longitude" label-width="100px">
                <el-select
                  v-model="personForm.destination_groundstaf_id"
                  placeholder="请选择姓名"
                  popper-class="selectPopperClass"
                  @visible-change="checkCanSelect2"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="user in users2"
                    :key="user.id"
                    :label="user.username"
                    :value="user.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" prop="longitude" label-width="100px">
                <el-select
                  v-model="personForm.department_id2"
                  placeholder="请选择部门"
                  popper-class="selectPopperClass"
                  @change="changeDepartment2"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.id"
                    :label="department.name"
                    :value="department.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="taskPlanCommonFormRow">
              <label class="rowTitle">保障员</label>
              <el-form-item label="姓名" prop="longitude" label-width="100px">
                <el-select
                  v-model="personForm.security_id"
                  placeholder="请选择姓名"
                  popper-class="selectPopperClass"
                  @visible-change="checkCanSelect3"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="user in users3"
                    :key="user.id"
                    :label="user.username"
                    :value="user.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" prop="longitude" label-width="100px">
                <el-select
                  v-model="personForm.department_id3"
                  placeholder="请选择部门"
                  popper-class="selectPopperClass"
                  @change="changeDepartment3"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.id"
                    :label="department.name"
                    :value="department.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="taskPlanCommonFormRow">
              <label class="rowTitle">任务控制</label>
              <el-form-item label="姓名" prop="task_controller_id" label-width="100px">
                <el-select
                  v-model="personForm.task_controller_id"
                  placeholder="请选择姓名"
                  popper-class="selectPopperClass"
                  @visible-change="checkCanSelect4"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="user in users4"
                    :key="user.id"
                    :label="user.username"
                    :value="user.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" prop="longitude" label-width="100px">
                <el-select
                  v-model="personForm.department_id4"
                  placeholder="请选择部门"
                  popper-class="selectPopperClass"
                  @change="changeDepartment4"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.id"
                    :label="department.name"
                    :value="department.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="taskPlanCommonFormRow">
              <label class="rowTitle">飞手</label>
              <el-form-item label="姓名" prop="flyer_id" label-width="100px">
                <el-select
                  v-model="personForm.flyer_id"
                  placeholder="请选择姓名"
                  popper-class="selectPopperClass"
                  @visible-change="checkCanSelect5"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="user in users5"
                    :key="user.id"
                    :label="user.username"
                    :value="user.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" prop="longitude" label-width="100px">
                <el-select
                  v-model="personForm.department_id5"
                  placeholder="请选择部门"
                  popper-class="selectPopperClass"
                  @change="changeDepartment5"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.id"
                    :label="department.name"
                    :value="department.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="taskPlanCommonFormRow">
              <label class="rowTitle">审核员</label>
              <el-form-item label="姓名" prop="auditor_id" label-width="100px">
                <el-select
                  v-model="personForm.auditor_id"
                  placeholder="请选择姓名"
                  popper-class="selectPopperClass"
                  @visible-change="checkCanSelect6"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="user in users6"
                    :key="user.id"
                    :label="user.username"
                    :value="user.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" prop="longitude" label-width="100px">
                <el-select
                  v-model="personForm.department_id6"
                  placeholder="请选择部门"
                  popper-class="selectPopperClass"
                  @change="changeDepartment6"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.id"
                    :label="department.name"
                    :value="department.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- <div class="taskPlanCommonFormDescRow">
              <label>备注</label>
              <el-form-item label="" prop="desc" label-width="0px">
                <el-input
                  v-model="personForm.desc"
                  type="textarea"
                  @input="change($event)"
                  maxlength="200"
                ></el-input>
              </el-form-item>
            </div> -->
          </el-form>
          <el-button class="rightCommonButton" @click="selectDesignatedPersonnel"
            >确定</el-button
          >
        </div>

        <div
          v-show="taskplanPointShow"
          class="rightMainContainer rightTaskplanPointContainer"
        >
          <div class="rightCommonTitle">
            <div class="title">驻点选择</div>
            <div class="separator"></div>
          </div>

          <div class="taskPlanCommonTableContainer">
            <div class="taskPlanCommonTableHeader">
              <img :src="pointStartIcon" /><label>起点</label>
            </div>
            <el-table
              :data="taskplanPointTableData"
              class="taskPlanCommonTable"
              @row-click="clickTaskplanPointRow1"
              style="width: 100%"
              height="195"
              ref="commonTablePoint1"
              tooltip-effect="light"
              :row-class-name="startStayPointRowClassName"
            >
              <el-table-column :show-overflow-tooltip="true" width="46">
                <template slot-scope="scope">
                  <el-radio v-model="start_station_id" :label="scope.row.id"
                    >&nbsp;</el-radio
                  >
                </template> </el-table-column
              ><el-table-column
                :show-overflow-tooltip="true"
                prop="name"
                label="名称"
                width="100"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="name"
                label="编号"
                width="119"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="type"
                label="类型"
                width="137"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="longitude"
                label="经度"
                width="137"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="latitude"
                label="纬度"
                width="134"
              >
              </el-table-column>
            </el-table>
          </div>

          <div class="taskPlanCommonTableContainer">
            <div class="taskPlanCommonTableHeader">
              <img :src="pointEndIcon" /><label>终点</label>
            </div>
            <el-table
              :data="taskplanPointTableData"
              class="taskPlanCommonTable"
              @row-click="clickTaskplanPointRow2"
              style="width: 100%"
              height="195"
              ref="commonTablePoint2"
              tooltip-effect="light"
              :row-class-name="endStayPointRowClassName"
            >
              <el-table-column :show-overflow-tooltip="true" width="46">
                <template slot-scope="scope">
                  <el-radio v-model="end_station_id" :label="scope.row.id"
                    >&nbsp;</el-radio
                  >
                </template> </el-table-column
              ><el-table-column
                :show-overflow-tooltip="true"
                prop="name"
                label="名称"
                width="100"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="name"
                label="编号"
                width="119"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="type"
                label="类型"
                width="137"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="longitude"
                label="经度"
                width="137"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="latitude"
                label="纬度"
                width="134"
              >
              </el-table-column>
            </el-table>
          </div>

          <div class="bottomSeparator"></div>

          <el-button class="rightCommonButton" @click="selectTaskplanPoint(false)"
            >确定</el-button
          >
        </div>

        <div
          v-show="routePlanningShow"
          class="rightMainContainer rightRoutePlanningContainer"
        >
          <div class="rightCommonTitle">
            <div class="title">航路规划</div>
            <div class="routePlanningTypeCheckContainer">
              <!-- <el-button
                class="routePlanningBtn left"
                :class="{
                  'select-btn': routePlanningType,
                }"
                @click="routePlanningType = true"
                >历史航迹</el-button
              > -->
              <!-- 暂时屏蔽 -->
              <!-- <el-button
                class="routePlanningBtn right"
                :class="{
                  'select-btn': !routePlanningType,
                }"
                @click="routePlanningType = false"
                >智能规划</el-button
              > -->
            </div>
            <div class="separator"></div>
          </div>

          <div class="taskPlanCommonTableContainer">
            <el-table
              :data="routePlanningTableData1"
              class="taskPlanCommonTable"
              @row-click="clickRoutePlanningRow1"
              style="width: 100%"
              height="478"
              ref="commonTable"
              v-show="routePlanningType"
              tooltip-effect="light"
              :row-class-name="routePlanningRowClassName1"
            >
              <el-table-column :show-overflow-tooltip="true" width="46">
                <template slot-scope="scope">
                  <el-radio v-model="selectRoutePlanningId1" :label="scope.row.id"
                    >&nbsp;</el-radio
                  >
                </template> </el-table-column
              ><el-table-column
                :show-overflow-tooltip="true"
                prop="name"
                label="名称"
                width="100"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="local_id"
                label="编号"
                width="110"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="create_time"
                label="创建时间"
                width="177"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="total_mileage"
                label="航向长度"
                width="90"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="average_altiude"
                label="飞行高度"
                width="90"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="point_count"
                label="航点数"
                width="70"
              >
              </el-table-column>
            </el-table>

            <el-table
              :data="routePlanningTableData2"
              class="taskPlanCommonTable"
              @row-click="clickRoutePlanningRow2"
              style="width: 100%"
              :max-height="478"
              ref="commonTable"
              v-show="!routePlanningType"
              tooltip-effect="light"
              :row-class-name="routePlanningRowClassName2"
            >
              <el-table-column :show-overflow-tooltip="true" width="76" label="ID">
                <template slot-scope="scope">
                  <el-radio v-model="selectRoutePlanningId2" :label="scope.row.id"
                    >&nbsp;</el-radio
                  >
                </template> </el-table-column
              ><el-table-column
                :show-overflow-tooltip="true"
                prop="lng"
                label="经度"
                width="200"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="lat"
                label="纬度"
                width="200"
              >
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="height"
                label="高度"
                width="180"
              >
              </el-table-column>
            </el-table>
          </div>

          <div class="bottomSeparator"></div>

          <el-button
            class="rightCommonButton rightCommonRoutePlanningBtn"
            @click="changeIsRoutePlanning"
            >航路规划</el-button
          >
          <el-button class="rightCommonButton" @click="selectRoutePlanning"
            >确定</el-button
          >
        </div>

        <div v-show="uavSelectShow" class="rightMainContainer rightUavSelectContainer">
          <div class="rightCommonTitle">
            <div class="title">无人机选择</div>
            <div class="separator"></div>
          </div>

          <div class="uavSelectUavShowContainer">
            <div
              class="uavSelectUavShowRow"
              v-for="uav in uavTables"
              :key="uav.id"
              @click="clickUavRow(uav)"
            >
              <img :src="'/minio' + uav.pic_url" />
              <el-radio
                v-model="taskPlanForm.plane_id"
                :label="uav.id"
                class="uavSelectRadio"
              ></el-radio>
              <div class="separator"></div>
              <div class="uavInfoContainer">
                <div class="uasSerialId">
                  <el-tooltip
                      class="item"
                      effect="light"
                      v-if="uav.name"
                      :content="uav.name"
                      placement="top"
                      :disabled="uav.name.length <= 20"
                    >
                      <span> {{ uav.name.length > 20 ?  uav.name.slice(0, 20) + '...' : uav.name}} </span>
                    </el-tooltip>
                </div>
                <div class="uavInfoRow">
                  <div class="left">
                    <label class="title">编号</label
                    ><label class="content">{{ uav.uas_serial_id }}</label>
                  </div>
                  <div class="right">
                    <label class="title">巡航速度</label>
                    <label class="content">{{ uav.cruise_speed + 'km/h' }}</label>
                  </div>
                </div>
                <div class="uavInfoRow">
                  <div class="left">
                    <label class="title">型号</label
                    ><label class="content">{{ uav.uav_model_name }}</label>
                  </div>
                  <div class="right">
                    <label class="title">续航时间</label>
                    <label class="content">{{ uav.max_fly_time + 'min' }}</label>
                  </div>
                </div>
                <div class="uavInfoRow">
                  <div class="left">
                    <label class="title">类型</label
                    ><label class="content">{{ uav.uav_type_name }}</label>
                  </div>
                  <div class="right">
                    <label class="title">升限</label>
                    <label class="content">{{ uav.uav_ceiling + 'm' }}</label>
                  </div>
                </div>
                <div class="uavInfoRow">
                  <div class="left">
                    <label class="title">生产厂商</label
                    ><label class="content">{{ uav.company_name }}</label>
                  </div>
                  <div class="right">
                    <label class="title">最大载荷</label>
                    <label class="content">{{ uav.max_payload + 'kg' }}</label>
                  </div>
                </div>
                <div class="uavInfoRow">
                  <div class="left">
                    <label class="title">机载通信</label
                    ><label class="content">{{ uav.airborne_communication_name }}</label>
                  </div>
                  <div class="right">
                    <label class="title"></label>
                    <label class="content"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="bottomSeparator"></div>

          <el-button class="rightCommonButton" @click="selectUavSelect">确定</el-button>
        </div>

        <div v-show="planCirculationInfoShow" class="rightMainContainer">
          <div class="rightCommonTitle">
            <div class="title">计划流转信息</div>
            <div class="separator"></div>
          </div>
          <div class="planCirculationInfoShowContainer">
            <el-timeline class="planCirculationInfoShowContainerInfo" :reverse="true">
              <el-timeline-item
                placement="top"
                v-for="(planCirculationInfo, index) in planCirculationInfos"
                :class="index === planCirculationInfos.length - 1 ? 'fontFFA63E' : ''"
                :key="index"
                :icon="index === planCirculationInfos.length - 1 ? 'el-icon-check' : ''"
                :color="index === planCirculationInfos.length - 1 ? '#FFA63E' : '#fff'"
                :size="index === planCirculationInfos.length - 1 ? 'large' : 'normal'"
                :timestamp="planCirculationInfo.timestamp"
              >
                {{ planCirculationInfo.content }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>

        <div
          v-show="noteTaskPlanShow"
          class="rightMainContainer rightNoteTaskPlanContainer"
        >
          <div class="rightCommonTitle">
            <div class="title">备注</div>
            <div class="separator"></div>
          </div>

          <div class="noteTaskPlanShowContainer">
            <div class="planningContainer" v-show="currentProgress == 'planningProgress'">
              <div class="title">历史备注：</div>
              <div class="content" v-html="noteInfo"></div>
              <div class="seperator"></div>
              <el-input
                type="textarea"
                maxlength="500"
                placeholder="请输入备注(500字以内)"
                v-model="taskPlanForm.note"
              ></el-input>
            </div>
            <div
              class="submittedContainer"
              v-show="currentProgress == 'submittedProgress'"
            >
              <div class="title">历史备注：</div>
              <div class="content" v-html="noteInfo"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightRejectTopDiv" v-show="currentProgress == 'rejectedProgress'">
        <div class="rightRejectTitle">
          <label>
            {{
              activeAccordionName == "planCirculationInfo" ? "计划流转信息" : "驳回意见"
            }}
          </label>
        </div>
        <div class="rightRejectContent">
          <div
            class="content"
            v-html="noteInfo"
            v-if="activeAccordionName !== 'planCirculationInfo'"
          ></div>
          <div class="content planCirculationInfoShowContainer" v-else>
            <el-timeline class="planCirculationInfoShowContainerInfo" :reverse="true">
              <el-timeline-item
                placement="top"
                v-for="(planCirculationInfo, index) in planCirculationInfos"
                :class="index === planCirculationInfos.length - 1 ? 'fontFFA63E' : ''"
                :key="index"
                :icon="index === planCirculationInfos.length - 1 ? 'el-icon-check' : ''"
                :color="index === planCirculationInfos.length - 1 ? '#FFA63E' : '#fff'"
                :size="index === planCirculationInfos.length - 1 ? 'large' : 'normal'"
                :timestamp="planCirculationInfo.timestamp"
              >
                {{ planCirculationInfo.content }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>

      <div class="rightBottomDiv" v-if="null !== savePermission">
        <el-button
          class="saveButton"
          v-show="currentProgress == 'planningProgress'"
          @click="saveTaskPlan"
        >
          保存</el-button
        >
        <el-button
          class="submitButton"
          v-if="currentProgress == 'planningProgress'"
          @click="submitTaskPlan"
        >
          {{ savePermission.name }}
        </el-button>
        <el-button
          class="editButton"
          v-if="
            null !== editPermission &&
            (currentProgress == 'submittedProgress' ||
              currentProgress == 'rejectedProgress')
          "
          @click="updateTaskPlan"
        >
          {{ editPermission.name }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import taskIcon from "../../../assets/img/home/task.png";
import goodsIcon from "../../../assets/img/home/goods.png";
import goodsNumIcon from "../../../assets/img/home/goodsNum.png";
import goodsWeightIcon from "../../../assets/img/home/goodsWeight.png";
import minimum from "../../../assets/img/home/minimum.png";
import minimumUnchecked from "../../../assets/img/home/minimumUnchecked.png";
import secondary from "../../../assets/img/home/secondary.png";
import secondaryUnchecked from "../../../assets/img/home/secondaryUnchecked.png";
import highest from "../../../assets/img/home/highest.png";
import highestUnchecked from "../../../assets/img/home/highestUnchecked.png";

import pointStartIcon from "../../../assets/img/taskPlan/pointStartIcon.png";
import pointEndIcon from "../../../assets/img/taskPlan/pointEndIcon.png";

import LowIconTP from "../../../assets/img/taskPlan/lowIconTP.png";
import MediumIconTP from "../../../assets/img/taskPlan/mediumIconTP.png";
import HignIconTP from "../../../assets/img/taskPlan/hignIconTP.png";

import parkingApron1 from "../../../assets/img/taskPlan/parkingApron1.png";
import parkingApron1Hover from "../../../assets/img/taskPlan/parkingApron1Hover.png";
import parkingApron2 from "../../../assets/img/taskPlan/parkingApron2.png";
import parkingApron2Hover from "../../../assets/img/taskPlan/parkingApron2Hover.png";

import JsBarcode from "jsbarcode";
import tooltipOver from "../../tools/tooltipOver";

const opacity1 = "opacity: 1;";
const opacity04 = "opacity: 0.4;";

const newTaskProgress = "newTaskProgress";
const planningProgress = "planningProgress";
const submittedProgress = "submittedProgress";
const rejectedProgress = "rejectedProgress";

const progressChange = "progressChange";

export default {
  name: "OtherTaskPlanning",
  props: [
    "userInfo",
    "opacityInfos",
    "numInfos",
    "currentProgress",
    "selectMissionId",
    "savePermission",
    "editPermission",
    "delPermission",
    "openTab",
  ],
  data() {
    return {
      selectFlightId: null,
      clickPlanRowFlag: false,

      minimum: minimumUnchecked,
      secondary: secondaryUnchecked,
      highest: highestUnchecked,

      lowIconTPSrc: LowIconTP,
      mediumIconSrc: MediumIconTP,
      highIconSrc: HignIconTP,

      parkingApron1: parkingApron1,
      parkingApron1Hover: parkingApron1Hover,
      parkingApron2: parkingApron2,
      parkingApron2Hover: parkingApron2Hover,

      goodsTotalNum: 0,
      goodsNum: 0,
      // 货物总重量
      goodsTotalWeight: 0,
      // 货物名称
      goodsName: "",
      queryTaskForm: {
        name: "",
        priority: 1,
        status: "",
        is_removed: 0,
        currentpage: 1,
        pagesize: 0,
      },
      taskList: [],
      taskIcon: taskIcon,
      goodsIcon: goodsIcon,
      goodsNumIcon: goodsNumIcon,
      goodsWeightIcon: goodsWeightIcon,
      //取货完成的需求
      taskPlanForm: {
        airLink: {},
        uav: { uavmodel: {} },
        starstaypoint: {},
        endstaypoint: {},
      },
      start_station_id: null,
      end_station_id: null,
      goodsTableData: [],

      users1: [],
      users2: [],
      users3: [],
      users4: [],
      users5: [],
      users6: [],
      userIdNames: [
        "customer_groundstaf_id",
        "destination_groundstaf_id",
        "security_id",
        "task_controller_id",
        "flyer_id",
        "auditor_id",
      ],
      // 属性
      attributes: [
        {
          id: "0",
          label: "易碎性",
        },
        {
          id: "1",
          label: "易爆性",
        },
        {
          id: "2",
          label: "易燃性",
        },
        {
          id: "3",
          label: "腐蚀性",
        },
      ],
      // 密级
      goodsSecrecies: {
        0: { 0: "非", 1: "密" },
        1: { 0: "秘", 1: "密" },
        2: { 0: "机", 1: "密" },
        3: { 0: "绝", 1: "密" },
      },
      designatedPersonnel: "designatedPersonnel",
      uavSelect: "uavSelect",
      pointStartIcon: pointStartIcon,
      pointEndIcon: pointEndIcon,
      queryTimeInfo: {},
      activeAccordionName: "deliveryTime", //当前打开的手风琴名称

      airLinkTableData: [],
      selectGoodsIds: [],
      goodsTableData: [],
      start_station_id: 1,
      taskplanPointTableData: [],
      end_station_id: 1,
      selectRoutePlanningId1: null,
      routePlanningTableData1: [],
      selectRoutePlanningId2: null,
      routePlanningTableData2: [],
      uavTables: [],
      personForm: {}, // 表单验证
      taskPlanFormRules: {},
      personFormRules: {},
      departments: [],
      routePlanningType: true, //航线规划类型,true 历史航迹 false 智能规划
      minDeliveryStartTime: new Date().getTime(),
      deliveryStartTime: {
        disabledDate: (time) => {
          return time.getTime() < this.$data.minDeliveryStartTime - 8.64e7;
        },
      },
      linkTypes: [
        {
          id: 0,
          name: "M4G",
        },
        {
          id: 1,
          name: "J4G",
        },
        {
          id: 2,
          name: "M5G",
        },
        {
          id: 3,
          name: "J5G",
        },
        {
          id: 4,
          name: "电台",
        },
        {
          id: 5,
          name: "卫通",
        },
      ],
      // 存储计划流转信息
      planCirculationInfos: [],
      noteInfo: "",
      goodsCount: 0,
      goodsWeight: 0,
    };
  },
  components: {
    "tooltip-over": tooltipOver,
  },
  methods: {
    change(e) {
      this.$forceUpdate();
    },
    cleanLimitTime() {
      this.$set(this.$data.taskPlanForm, "limit_time", null);
    },
    newTask() {
      if (this.openTab !== newTaskProgress) {
        this.$emit(progressChange, newTaskProgress);
      }
    },
    planning() {
      if (this.openTab !== planningProgress) {
        this.$emit(progressChange, planningProgress);
        this.$data.clickPlanRowFlag = false;
      }
    },
    submitted() {
      if (this.openTab !== submittedProgress) {
        this.$emit(progressChange, submittedProgress);
        this.$data.clickPlanRowFlag = false;
      }
    },
    rejected() {
      if (this.openTab !== rejectedProgress) {
        this.$emit(progressChange, rejectedProgress);
        this.$data.clickPlanRowFlag = false;
      }
    },
    choosePriority(priority) {
      this.$data.taskPlanForm.priority = priority;
      if (1 === priority) {
        this.minimum = minimum;
        this.secondary = secondaryUnchecked;
        this.highest = highestUnchecked;
      } else if (2 === priority) {
        this.minimum = minimumUnchecked;
        this.secondary = secondary;
        this.highest = highestUnchecked;
      } else if (3 === priority) {
        this.minimum = minimumUnchecked;
        this.secondary = secondaryUnchecked;
        this.highest = highest;
      }
    },
    setLimitTime(value) {
      this.$set(this.$data.taskPlanForm, "limit_time", value);
    },
    startTimeChange() {
      const taskPlanForm = this.$data.taskPlanForm;
      const startAt = taskPlanForm.start_at
        .replace(/-/g, "")
        .replace(/ /g, "")
        .replace(/:/g, "");

      const current = this.$moment(new Date())
        .format("YYYY-MM-DD HH:mm:ss")
        .replace(/-/g, "")
        .replace(/ /g, "")
        .replace(/:/g, "");

      if (startAt < current) {
        this.confirmMessage(false, "开始时间不能小于当前时间");
        return;
      }

      this.startEndTimeChange();
    },
    startEndTimeChange() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (taskPlanForm.start_at && taskPlanForm.end_at) {
        const startAt = taskPlanForm.start_at
          .replace(/-/g, "")
          .replace(/ /g, "")
          .replace(/:/g, "");

        const endAt = taskPlanForm.end_at
          .replace(/-/g, "")
          .replace(/ /g, "")
          .replace(/:/g, "");

        if (endAt < startAt) {
          this.confirmMessage(false, "开始时间不能大于结束时间");
          return false;
        }
      }
      return true;
    },
    changeDepartment1(value) {
      this.$data.personForm.customer_groundstaf_id = null;
      this.changeDepartment(1, value);
    },
    changeDepartment2(value) {
      this.$data.personForm.destination_groundstaf_id = null;
      this.changeDepartment(2, value);
    },
    changeDepartment3(value) {
      this.$data.personForm.security_id = null;
      this.changeDepartment(3, value);
    },
    changeDepartment4(value) {
      this.$data.personForm.task_controller_id = null;
      this.changeDepartment(4, value);
    },
    changeDepartment5(value) {
      this.$data.personForm.flyer_id = null;
      this.changeDepartment(5, value);
    },
    changeDepartment6(value) {
      this.$data.personForm.auditor_id = null;
      this.changeDepartment(6, value);
    },
    changeDepartment(type, value) {
      const roleName = this.getRoleName(type);
      this.getUsers(type, roleName, value);
    },
    getRoleName(type) {
      if (1 == type || 2 == type) {
        return "地面保障员";
      } else if (3 == type) {
        return "环境保障员";
      } else if (4 == type) {
        return "任务控制员";
      } else if (5 == type) {
        return "飞行控制员";
      } else if (6 == type) {
        return "态势监控员";
      }
    },
    checkCanSelect1(value) {
      this.checkCanSelect(1, value);
    },
    changeSelectUser(value) {
      this.$forceUpdate();
    },
    checkCanSelect2(value) {
      this.checkCanSelect(2, value);
    },
    checkCanSelect3(value) {
      this.checkCanSelect(3, value);
    },
    checkCanSelect4(value) {
      this.checkCanSelect(4, value);
    },
    checkCanSelect5(value) {
      this.checkCanSelect(5, value);
    },
    checkCanSelect6(value) {
      this.checkCanSelect(6, value);
    },
    checkCanSelect(type, value) {
      if (value) {
        const personForm = this.$data.personForm;
        if (this.isEmptyStr(personForm["department_id" + type])) {
          this.confirmMessage(false, "请先选择部门再选择人员");
        }
      }
    },
    clickTaskRow(row) {
      this.$data.activeAccordionName = ""; //关闭手风琴及隐藏最右侧操作框
      this.$data.selectFlightId = row.id;
      this.queryTaskPlanById(row.id);
    },
    taskRowClassName({ row, rowIndex }) {
      if (this.$data.selectFlightId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    queryTaskPlanById(id) {
      this.getRequest("/uav-task-server/flight/queryFlight.do?id=" + id).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          const newData = this.resetTaskPlanInfos(oData.data);
          const taskPlanForm = (this.$data.taskPlanForm = newData);
          if (taskPlanForm.user_id) {
            this.queryTaskPlanUser(taskPlanForm, taskPlanForm.user_id);
          }
          this.choosePriority(taskPlanForm.priority);
          this.$data.clickPlanRowFlag = true;
          // 赋值 计划流转信息 数据
          this.planCirculationInfos = JSON.parse(oData.data.flight.plan_transfer_note);
          this.$forceUpdate();
        } else if (oData.code != 401) {
          this.confirmMessage(false, oData.msg);
        }
      });
    },
    queryTaskPlanUser(taskPlanForm, id) {
      let vue = this;
      this.postJsonRequest("/user-server/api/u-user/getUsersByCondition", {
        idList: [id],
      }).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (!this.isEmptyArray(data) && id == data[0].id) {
            this.$set(taskPlanForm, "user_no", data[0].userNo);
          }
        }
      });
    },
    resetTaskPlanInfos(data) {
      this.$data.noteInfo = ""; //驳回注释设置为空
      const newData = data.flight;
      if (data.flight) {
        this.$data.start_station_id = newData.start_station_id;
        this.$data.end_station_id = newData.end_station_id;
        newData.routePlanningName = newData.airline_name;

        try {
          if (!this.isEmptyStr(newData.note)) {
            const noteInfos = newData.note.split("$");
            for (let index = 0; index < noteInfos.length; index++) {
              try {
                const element = noteInfos[index];
                if (!this.isEmptyStr(element)) {
                  this.$data.noteInfo += element + "<br/>";
                }
              } catch (error) {}
            }
          }
        } catch (error) {}
        newData.note = "";

        try {
          if (!this.isEmptyStr(newData.task_coordinate_waypoints)) {
            const points = newData.task_coordinate_waypoints.split(";");
            newData.point_count = points.length;
          }
        } catch (error) {}

        if (data.airlink) {
          newData.airLink = data.airlink;
          try {
            if (null != newData.airLink.type) {
              newData.airLink.typeName = this.$data.linkTypes[newData.airLink.type].name;
            }
          } catch (error) {}
        }
        if (data.uav) {
          newData.uav = data.uav;
          if (newData.uav.uavmodel) {
            for (const key in newData.uav.uavmodel) {
              if (key !== "name") {
                newData.uav[key] = newData.uav.uavmodel[key];
              }
            }
          }
        }
        if (data.starstaypoint) {
          newData.starstaypoint = data.starstaypoint;
        }
        if (data.endstaypoint) {
          newData.endstaypoint = data.endstaypoint;
        }
        this.reselectUser(newData, data, "customer_groundstaf", "1");
        this.reselectUser(newData, data, "destination_groundstaf", "2");
        this.reselectUser(newData, data, "security", "3");
        this.reselectUser(newData, data, "task_controller", "4");
        this.reselectUser(newData, data, "flyer", "5");
        this.reselectUser(newData, data, "auditor", "6");
        if (!this.isEmptyArray(data.lsgoods)) {
          const lsgoods = data.lsgoods;
          newData.selectGoodsIds = [];
          for (let index = 0; index < lsgoods.length; index++) {
            const element = lsgoods[index];
            newData.selectGoodsIds.push(element.id);
          }
        }
      }

      return newData;
    },
    reselectUser(obj, data, objName, key) {
      const personForm = this.$data.personForm;
      if (data && data[objName]) {
        obj["userName" + key] = data[objName].username;
        obj[objName + "_id"] = data[objName].id;
        personForm[objName + "_id"] = data[objName].id;
        this.$set(personForm, "department_id" + key, data[objName].departmentId);
        if (
          planningProgress == this.currentProgress ||
          submittedProgress == this.currentProgress
        ) {
          this.changeDepartment(key, personForm["department_id" + key]);
        }
      }
    },
    addInsuredValue() {
      if (this.currentProgress === rejectedProgress) {
        return;
      }
      const taskPlanForm = this.$data.taskPlanForm;
      let data = 0;
      if (null != taskPlanForm.f2 && !isNaN(taskPlanForm.f2)) {
        data = parseFloat(taskPlanForm.f2);
      }
      data++;
      if (999999999 < data) {
        data = 999999999;
      }
      this.$set(this.$data.taskPlanForm, "f2", data);
    },
    reduceInsuredValue() {
      if (this.currentProgress === rejectedProgress) {
        return;
      }
      const taskPlanForm = this.$data.taskPlanForm;
      let data = 1;
      if (null != taskPlanForm.f2 && !isNaN(taskPlanForm.f2)) {
        data = parseFloat(taskPlanForm.f2);
      }
      data--;
      if (data < 0) {
        data = 0;
      }
      this.$set(this.$data.taskPlanForm, "f2", data);
    },
    selectPriority() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (null == taskPlanForm.priority) {
        this.confirmMessage(false, "请选择任务优先级");
        return false;
      }
      return true;
    },
    selectDeliveryTime() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (null == taskPlanForm.start_at || "" == taskPlanForm.start_at) {
        this.confirmMessage(false, "请选择开始时间");
        return false;
      } else if (null == taskPlanForm.end_at || "" == taskPlanForm.end_at) {
        this.confirmMessage(false, "请选择结束时间");
        return false;
      }
      return this.startEndTimeChange();
    },
    selectLimitTime() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (1 == taskPlanForm.is_limit && this.isEmptyStr(taskPlanForm.limit_time)) {
        this.confirmMessage(false, "请选择限时时间");
        return false;
      }
      if (0 == taskPlanForm.is_limit) {
        this.$set(taskPlanForm, "limit_time", null);
      }
      return true;
    },
    selectInsuredValue() {
      const taskPlanForm = this.$data.taskPlanForm;
      let msg = null;
      if (isNaN(taskPlanForm.f2)) {
        msg = "保价金额需要为数字值";
      } else if (taskPlanForm.f2 < 0) {
        msg = "保价金额不能小于0";
      } else if (999999999 < taskPlanForm.f2) {
        msg = "保价金额不能大于999999999";
      }

      if (msg) {
        this.confirmMessage(false, msg);
        return false;
      }
      return true;
    },
    selectGoodsPlan(flag) {
      const taskPlanForm = this.$data.taskPlanForm;
      if (this.isEmptyArray(taskPlanForm.selectGoodsIds)) {
        this.confirmMessage(false, "请选择货物");
        return false;
      }
      //提示选择成功
      if (flag) {
        this.$message({
          message: "选择货物成功",
          duration: 1000,
          customClass: "message-s",
          iconClass: "el-icon-ok-tip",
          offset: 470,
          onClose: function () {},
        });
      }
      return true;
    },
    selectLinkPlanning() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (null == taskPlanForm.link_id || "" == taskPlanForm.link_id) {
        this.confirmMessage(false, "请选择链路");
        return false;
      }
      if (null != taskPlanForm.tempAirLink) {
        taskPlanForm.airLink = taskPlanForm.tempAirLink;
        try {
          if (null != taskPlanForm.airLink.type) {
            taskPlanForm.airLink.typeName = this.$data.linkTypes[
              taskPlanForm.airLink.type
            ].name;
          }
        } catch (error) {}
      }
      return true;
    },
    selectDesignatedPersonnel() {
      const personForm = this.$data.personForm;
      const taskPlanForm = this.$data.taskPlanForm;
      const userIdNames = this.$data.userIdNames;
      for (let index = 0; index < userIdNames.length; index++) {
        const element = userIdNames[index];
        taskPlanForm[element] = personForm[element];
      }
      this.setUserNames();
      this.selectDesignatedPersonnel2();
    },
    setUserNames() {
      const taskPlanForm = this.$data.taskPlanForm;
      const userIdNames = this.$data.userIdNames;
      for (let index = 0; index < userIdNames.length; index++) {
        const element = userIdNames[index];
        const userName = this.getUserName(
          taskPlanForm[element],
          this.$data["users" + (index + 1)]
        );
        this.$set(taskPlanForm, "userName" + (index + 1), userName);
      }
    },
    getUserName(id, users) {
      if (!this.isEmptyArray(users)) {
        for (let index = 0; index < users.length; index++) {
          const element = users[index];
          if (id == element.id) {
            return element.username;
          }
        }
      }
      return "";
    },
    selectDesignatedPersonnel2() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (
        null == taskPlanForm.customer_groundstaf_id ||
        "" == taskPlanForm.customer_groundstaf_id
      ) {
        this.confirmMessage(false, "请选择发货地勤");
        return false;
      }
      if (
        null == taskPlanForm.destination_groundstaf_id ||
        "" == taskPlanForm.destination_groundstaf_id
      ) {
        this.confirmMessage(false, "请选择收货地勤");
        return false;
      }
      if (null == taskPlanForm.security_id || "" == taskPlanForm.security_id) {
        this.confirmMessage(false, "请选择保障员");
        return false;
      }
      if (
        null == taskPlanForm.task_controller_id ||
        "" == taskPlanForm.task_controller_id
      ) {
        this.confirmMessage(false, "请选择任务控制员");
        return false;
      }
      if (null == taskPlanForm.flyer_id || "" == taskPlanForm.flyer_id) {
        this.confirmMessage(false, "请选择飞手");
        return false;
      }
      if (null == taskPlanForm.auditor_id || "" == taskPlanForm.auditor_id) {
        this.confirmMessage(false, "请选择审核员");
        return false;
      }
      return true;
    },
    selectTaskplanPoint(flag) {
      const taskPlanForm = this.$data.taskPlanForm;
      let start_station_id = this.$data.start_station_id;
      let end_station_id = this.$data.end_station_id;
      if (flag) {
        start_station_id = taskPlanForm.start_station_id;
        end_station_id = taskPlanForm.end_station_id;
      }

      if (null == start_station_id || "" == start_station_id) {
        this.confirmMessage(false, "请选择出发驻点");
        return false;
      }
      if (null == end_station_id || "" == end_station_id) {
        this.confirmMessage(false, "请选择到达驻点");
        return false;
      }
      //如果选择的驻点修改了,则需要重新选择航路
      if (!flag) {
        if (
          start_station_id != taskPlanForm.start_station_id ||
          end_station_id != taskPlanForm.end_station_id
        ) {
          this.cleanAirLineData();
          taskPlanForm.start_station_id = start_station_id;
          taskPlanForm.end_station_id = end_station_id;
        }
      }

      if (taskPlanForm.start_station_id == taskPlanForm.end_station_id) {
        this.confirmMessage(false, "驻点起点和终点不能相同");
        return false;
      }
      if (null != taskPlanForm.tempstarstaypoint) {
        taskPlanForm.starstaypoint = taskPlanForm.tempstarstaypoint;
      }
      if (null != taskPlanForm.tempendstaypoint) {
        taskPlanForm.endstaypoint = taskPlanForm.tempendstaypoint;
      }
      return true;
    },
    cleanAirLineData() {
      const taskPlanForm = this.$data.taskPlanForm;
      this.$data.selectRoutePlanningId1 = null;
      this.$data.selectRoutePlanningId2 = null;
      taskPlanForm.routePlanningName = null;
      taskPlanForm.airline_name = null;
      taskPlanForm.task_coordinate_points = null;
      taskPlanForm.task_coordinate_waypoints = null;
      taskPlanForm.work_area = null;
      taskPlanForm.total_mileage = null;
      taskPlanForm.air_line_type = null;
      taskPlanForm.center_lon = null;
      taskPlanForm.center_lat = null;
      taskPlanForm.flight_speed = null;
      taskPlanForm.airline_angle = null;
      taskPlanForm.flihght_relative_altiude = null;
      taskPlanForm.compensate_altiude = null;
      taskPlanForm.field_angle = null;
      taskPlanForm.average_altiude = null;
      taskPlanForm.point_count = null;
      this.$forceUpdate();
    },
    selectRoutePlanning() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (this.isEmptyStr(taskPlanForm.routePlanningName)) {
        this.confirmMessage(false, "请选择航路");
        return false;
      }

      let tempRoutePlanning = this.$data.taskPlanForm.tempRoutePlanning;
      if (tempRoutePlanning) {
        this.$set(taskPlanForm, "airline_name", taskPlanForm.tempRoutePlanning.name);

        if (!this.isEmptyStr(tempRoutePlanning.name)) {
          taskPlanForm.airline_name = tempRoutePlanning.name;
        }
        if (!this.isEmptyStr(tempRoutePlanning.task_coordinate_points)) {
          taskPlanForm.task_coordinate_points = tempRoutePlanning.task_coordinate_points;
        }
        if (!this.isEmptyStr(tempRoutePlanning.task_coordinate_waypoints)) {
          taskPlanForm.task_coordinate_waypoints =
            tempRoutePlanning.task_coordinate_waypoints;
          try {
            taskPlanForm.point_count = tempRoutePlanning.point_count;
          } catch (error) {}
        }
        if (!this.isEmptyStr(tempRoutePlanning.work_area)) {
          taskPlanForm.work_area = tempRoutePlanning.work_area;
        }
        if (!this.isEmptyStr(tempRoutePlanning.total_mileage)) {
          taskPlanForm.total_mileage = tempRoutePlanning.total_mileage;
        }
        if (!this.isEmptyStr(tempRoutePlanning.air_line_type)) {
          taskPlanForm.air_line_type = tempRoutePlanning.air_line_type;
        }
        if (!this.isEmptyStr(tempRoutePlanning.center_lon)) {
          taskPlanForm.center_lon = tempRoutePlanning.center_lon;
        }
        if (!this.isEmptyStr(tempRoutePlanning.center_lat)) {
          taskPlanForm.center_lat = tempRoutePlanning.center_lat;
        }
        if (!this.isEmptyStr(tempRoutePlanning.flight_speed)) {
          taskPlanForm.flight_speed = tempRoutePlanning.flight_speed;
        }
        if (!this.isEmptyStr(tempRoutePlanning.airline_angle)) {
          taskPlanForm.airline_angle = tempRoutePlanning.airline_angle;
        }
        if (!this.isEmptyStr(tempRoutePlanning.flihght_relative_altiude)) {
          taskPlanForm.flihght_relative_altiude =
            tempRoutePlanning.flihght_relative_altiude;
        }
        if (!this.isEmptyStr(tempRoutePlanning.compensate_altiude)) {
          taskPlanForm.compensate_altiude = tempRoutePlanning.compensate_altiude;
        }
        if (!this.isEmptyStr(tempRoutePlanning.field_angle)) {
          taskPlanForm.field_angle = tempRoutePlanning.field_angle;
        }
        if (!this.isEmptyStr(tempRoutePlanning.average_altiude)) {
          taskPlanForm.average_altiude = tempRoutePlanning.average_altiude;
        }
      }
      this.$forceUpdate();
      return true;
    },
    changeIsRoutePlanning() {
      // 临时存储选中的 起始驻点数组
      let startEndPlanPointTableData = []
      this.taskplanPointTableData.forEach(item => {
        if (item.id === this.start_station_id) {
          startEndPlanPointTableData.push(item)
        }
      })
      this.taskplanPointTableData.forEach(item => {
        if (item.id === this.end_station_id) {
          startEndPlanPointTableData.push(item)
        }
      })

      // 临时存储选中的 航路规划线路
      let routePlanPointTableData = {}
      this.routePlanningTableData1.forEach(item => {
        if (item.id === this.$data.selectRoutePlanningId1) {
          routePlanPointTableData = item
        }
      })

      console.log(this.routePlanningTableData1)
      this.$emit("changeIsRoutePlanning", {
        show: true,
        id: this.$data.selectFlightId,
        routeId: this.$data.selectRoutePlanningId1,
        // routeId: routePlanPointTableData,
        startEndPlanPointTableData
      });
    },
    selectUavSelect() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (null == taskPlanForm.plane_id || "" == taskPlanForm.plane_id) {
        this.confirmMessage(false, "请选择无人机");
        return false;
      }
      if (null != taskPlanForm.tempUav) {
        taskPlanForm.uav = taskPlanForm.tempUav;
      }
      return true;
    },
    saveTaskPlan() {
      this.$data.taskPlanForm.flight_status = 10;
      this.saveOrSubmitTaskPlan("保存计划成功");
    },
    updateTaskPlan() {
      let tips = "<i class='el-icon-warn-tip'></i>确定修改该计划?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          const taskPlanForm = this.$data.taskPlanForm;
          if (this.currentProgress == rejectedProgress) {
            taskPlanForm.flight_status = 10;
            this.$data.nextProgress = planningProgress;
          }
          let callback =
            this.currentProgress == rejectedProgress ? this.afterTaskPlan : null;
          this.saveOrSubmitTaskPlan("修改计划成功", callback);
        })
        .catch((err) => {
          console.log(err);
        });
    }, //删除计划
    delTaskPlan() {
      let tips = "<i class='el-icon-warn-tip'></i>确定删除该计划?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.doDelTaskPlan();
        })
        .catch((err) => {
          console.log(err);
        });
    }, //执行计划删除
    doDelTaskPlan() {
      const taskPlanForm = this.$data.taskPlanForm;
      this.postRequest("/uav-task-server/flight/deleteFlight.do", {
        flight_id: taskPlanForm.id,
        mission_id: taskPlanForm.mission_id,
      }).then((res) => {
        let msg = "删除成功";
        let oData = res.data;
        if (oData.code === 0) {
          if (!this.isEmptyStr(oData.msg)) {
            msg = oData.msg;
          }
          this.$emit("getTaskPlanStatisics");
          this.$data.clickPlanRowFlag = false;
          this.queryTaskPlan(this.currentProgress); //重新查询列表数据
          this.confirmMessage(true, msg);
        } else if (oData.code != 401) {
          this.confirmMessage(false, oData.msg);
        }
      });
    },
    submitTaskPlan() {
      let tips = "<i class='el-icon-warn-tip'></i>确定提交该计划?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.$data.taskPlanForm.flight_status = 15;
          this.$data.nextProgress = submittedProgress;
          this.saveOrSubmitTaskPlan("提交计划成功", this.afterTaskPlan);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    afterTaskPlan() {
      this.$emit(progressChange, this.$data.nextProgress);
      this.$data.nextProgress = null;
      this.$data.clickPlanRowFlag = false;
      this.queryTaskPlanById(this.$data.taskPlanForm.id); //重新查询信息
      this.queryTaskPlan(this.currentProgress); //重新查询列表数据
    }, //获取货物id参数
    saveOrSubmitTaskPlan(msg, callback) {
      const taskPlanForm = this.$data.taskPlanForm;
      if (this.checkSubmitPlanData() && this.doOtherCheck()) {
        const lgoodsid = this.getGoodsParam();
        let url = "";
        if (null == taskPlanForm.id) {
          url = "/uav-task-server/flight/addFlightService.do?" + lgoodsid;
        } else {
          url = "/uav-task-server/flight/updateFlight.do?" + lgoodsid;
        }
        this.postJsonRequest(url, taskPlanForm).then((res) => {
          let oData = res.data;
          if (oData.code === 0) {
            if (!this.isEmptyStr(oData.msg)) {
              msg = oData.msg;
            }
            this.confirmMessage(true, msg);
            //复制最新数据到本地
            if (oData.data) {
              this.$data.selectFlightId = oData.data;
              this.queryTaskPlanById(oData.data);
            }

            this.$emit("getTaskPlanStatisics");
            if (callback) {
              callback();
            } else {
              this.queryTaskPlan(this.currentProgress); //重新查询列表数据
            }
          } else if (oData.code != 401) {
            this.confirmMessage(false, oData.msg);
          }
        });
      }
    }, //在提交计划时,进行其它的数据检查
    doOtherCheck() {
      const taskPlanForm = this.$data.taskPlanForm;
      if (taskPlanForm.is_target && !taskPlanForm.target_icon) {
        this.confirmMessage(false, "请选择引导图标");
        return false;
      }
      return true;
    },
    getGoodsParam() {
      let selectGoodsIds = this.$data.taskPlanForm.selectGoodsIds;
      let param = "";
      for (let index = 0; index < selectGoodsIds.length; index++) {
        const element = selectGoodsIds[index];
        if (0 != index) {
          param += "&";
        }
        param += "lgoodsid=" + element;
      }
      return param;
    },
    checkSubmitPlanData() {
      if (!this.selectPriority()) {
        return false;
      }
      if (!this.selectDeliveryTime()) {
        return false;
      }
      if (!this.selectLimitTime()) {
        return false;
      }
      if (!this.selectInsuredValue()) {
        return false;
      }
      if (!this.selectGoodsPlan()) {
        return false;
      }
      if (!this.selectLinkPlanning()) {
        return false;
      }
      if (!this.selectDesignatedPersonnel2()) {
        return false;
      }
      if (!this.selectTaskplanPoint(true)) {
        return false;
      }
      if (!this.selectRoutePlanning()) {
        return false;
      }
      if (!this.selectUavSelect()) {
        return false;
      }
      return true;
    },
    cancelClick() {
      console.log('11')
      // this.$emit(progressChange, newTaskProgress);
      this.$emit('cancelCreactPlan');
    }, //初始时创建空计划
    newEmptyPlan(missionId) {
      this.getMissionById(missionId);
    }, // 获取任务详情
    getMissionById(id) {
      this.postJsonRequest("/uav-task-server/mission/getMissionById.do", {
        id,
      }).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          const taskPlanForm = (this.$data.taskPlanForm = {
            airLink: {},
            starstaypoint: {},
            endstaypoint: {},
            uav: { uavmodel: {} },
            f2: 0,
          });
          this.$data.noteInfo = "";
          taskPlanForm.missionData = oData.data;
          taskPlanForm.mission_id = id;
          taskPlanForm.area_id = taskPlanForm.missionData.area_id;
          taskPlanForm.station_id = taskPlanForm.missionData.station_id;
          taskPlanForm.flight_name =
            "M" + taskPlanForm.missionData.mission_name.substr(1);
          taskPlanForm.deleteBtnShow = 1;
          this.choosePriority(taskPlanForm.missionData.priority);
          this.resetData();
          this.$data.clickPlanRowFlag = true;
          this.$forceUpdate();
        } else if (oData.code != 401) {
          this.confirmMessage(false, oData.msg);
        }
      });
    },
    resetData() {
      this.$data.activeAccordionName = "deliveryTime";
      this.$data.personForm = {};
      this.$data.start_station_id = null;
      this.$data.end_station_id = null;
      this.$data.selectRoutePlanningId1 = null;
      this.$data.selectRoutePlanningId2 = null;
    },
    clickGoodsRow(row, col, event) {
      let selectGoodsIds = this.$data.taskPlanForm.selectGoodsIds;
      if (null == selectGoodsIds) {
        selectGoodsIds = [];
      }
      if (-1 == selectGoodsIds.indexOf(row.id)) {
        selectGoodsIds.push(row.id);
      } else {
        selectGoodsIds.splice(selectGoodsIds.indexOf(row.id), 1);
      }
      this.$set(this.$data.taskPlanForm, "selectGoodsIds", selectGoodsIds);
      this.countTotalWeight();
    },
    countTotalWeight() {
      let selectGoodsIds = this.$data.taskPlanForm.selectGoodsIds;
      let goodsTableData = this.$data.goodsTableData;
      let goodsWeight = 0;
      let totalGoodsWeight = 0;
      for (let i = 0, len = goodsTableData.length; i < len; i++) {
        for (let index = 0; index < selectGoodsIds.length; index++) {
          const element = selectGoodsIds[index];
          if (element == goodsTableData[i].id) {
            goodsWeight += goodsTableData[i].goods_weight;
          }
        }
        totalGoodsWeight += goodsTableData[i].goods_weight;
      }
      this.$set(this.$data, "goodsWeight", totalGoodsWeight);
      this.$set(this.$data, "goodsCount", goodsTableData.length);
      this.$set(this.$data.taskPlanForm, "goodsWeight", goodsWeight);
      this.$set(this.$data.taskPlanForm, "goodsCount", selectGoodsIds.length);
    },
    clickAirLinkRow(row, col, event) {
      this.$data.taskPlanForm.tempAirLink = row;
      this.$set(this.$data.taskPlanForm, "link_id", row.id);
    },
    linkPlanningRowClassName({ row, rowIndex }) {
      if (this.$data.taskPlanForm.link_id === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    clickTaskplanPointRow1(row, col, event) {
      this.clickTaskplanPointRow(row, col, event, "start_station_id");
    },
    startStayPointRowClassName({ row, rowIndex }) {
      if (this.$data.taskPlanForm.start_station_id === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    clickTaskplanPointRow2(row, col, event) {
      this.clickTaskplanPointRow(row, col, event, "end_station_id");
    },
    endStayPointRowClassName({ row, rowIndex }) {
      if (this.$data.taskPlanForm.end_station_id === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    clickTaskplanPointRow(row, col, event, name) {
      const taskPlanForm = this.$data.taskPlanForm;
      let start_station_id = this.$data.start_station_id;
      let end_station_id = this.$data.end_station_id;
      if ("start_station_id" == name) {
        start_station_id = row.id;
      } else {
        end_station_id = row.id;
      }
      if (
        !this.isEmptyStr(start_station_id) &&
        !this.isEmptyStr(end_station_id) &&
        start_station_id == end_station_id
      ) {
        this.confirmMessage(false, "驻点起点和终点不能相同");
      } else {
        if ("start_station_id" == name) {
          taskPlanForm.tempstarstaypoint = row;
        } else {
          taskPlanForm.tempendstaypoint = row;
        }
        this.$set(this.$data, name, row.id);
      }
    },
    clickRoutePlanningRow1(row, col, event) {
      this.$set(this.$data, "selectRoutePlanningId1", row.id);
      this.$data.taskPlanForm.tempRoutePlanning = row;
      this.$set(this.$data.taskPlanForm, "routePlanningId", row.id);
      this.$set(this.$data.taskPlanForm, "routePlanningName", row.name);
      this.$forceUpdate();
    },
    routePlanningRowClassName1({ row, rowIndex }) {
      if (this.$data.selectRoutePlanningId1 === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    clickRoutePlanningRow2(row, col, event) {
      this.$data.selectRoutePlanningId2 = row.id;
      this.$data.taskPlanForm.tempRoutePlanning = row;
      this.$set(this.$data.taskPlanForm, "routePlanningId", row.id);
      this.$set(this.$data.taskPlanForm, "routePlanningName", row.name);
      this.$forceUpdate();
    },
    routePlanningRowClassName2({ row, rowIndex }) {
      if (this.$data.selectRoutePlanningId2 === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    clickUavRow(uav) {
      this.$data.taskPlanForm.tempUav = uav;
      this.$data.taskPlanForm.uas_serial_id = uav.id;
      this.$set(this.$data.taskPlanForm, "plane_id", uav.id);
    },
    getUsers(type, roleName, departmentId) {
      this.$set(this.$data, "users" + type, null);
      let vue = this;
      this.postJsonRequest("/user-server/api/u-user/queryByDepartmentIdAndRoleName", {
        roleName,
        departmentId,
      }).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.$set(this.$data, "users" + type, data);
          }
        } else if (oData.code != 401) {
          this.confirmMessage(false, "用户获取失败~");
        }
      });
    },
    queryDepartment() {
      if (!this.checkQueryData(this.$data.designatedPersonnel)) {
        return;
      }
      this.$data.queryTimeInfo[this.$data.designatedPersonnel] = new Date().getTime(); //设置查询时间

      let vue = this;
      this.postJsonRequest("/user-server/api/u-department/query?size=-1", {removed: 0})
        .then((res) => {
          res = res.data;
          if (null != res && !this.isEmptyArray(res.data.records)) {
            if (null != res.data) {
              this.$data.departments = res.data.records;
            } else {
              this.$data.departments = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            if (!this.isEmptyStr(res.msg)) {
              msg = res.msg;
            }
            this.confirmMessage(false, msg);
          }
        })
        .catch((error) => {});
    },
    queryUavs() {
      if (!this.checkQueryData(this.$data.uavSelect)) {
        return;
      }
      this.$data.queryTimeInfo[this.$data.uavSelect] = new Date().getTime(); //设置查询时间
      const taskPlanForm = this.$data.taskPlanForm;
      const station_id = taskPlanForm.station_id;
      const start_at = taskPlanForm.start_at;
      const end_at = taskPlanForm.end_at;
      let vue = this;
      this.getRequest(
        "/basic-info-server/uav/getAvailableUavListByFlightCondition.do?pagesize=0&currentpage=1&station_id=" +
          station_id +
          "&starttime=" +
          start_at +
          "&endtime=" +
          end_at
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.uavTables = res.data.list;
            } else {
              this.$data.uavTables = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            if (!this.isEmptyStr(res.msg)) {
              msg = res.msg;
            }
            this.confirmMessage(false, msg);
          }
        })
        .catch((error) => {});
    }, //查询当前任务可选货物列表
    queryRemainGoods() {
      const taskPlanForm = this.$data.taskPlanForm;
      const mission_id = taskPlanForm.mission_id;
      const flight_id = taskPlanForm.id;
      let param = "";
      if (mission_id) {
        param += "mission_id=" + mission_id;
      }
      if (flight_id) {
        param += "&flight_id=" + flight_id;
      }
      this.getRequest(
        "/uav-task-server/goods/queryGoodsByFlightAndMission.do?" + param
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.$data.goodsTableData = oData.data;
          this.countTotalWeight();
        } else if (oData.code != 401) {
          this.confirmMessage(false, "货物获取失败~");
        }
      });
    },
    // 获取链路列表
    getAirLinkList() {
      this.getRequest("/basic-info-server/airlink/getAllAirLinkList.do").then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.$data.airLinkTableData = oData.data;
        } else if (oData.code != 401) {
          this.confirmMessage(false, "链路获取失败~");
        }
      });
    },
    queryTaskPlan(nval) {
      if (!nval) {
        nval = this.currentProgress;
      }
      let flight_status = 10;
      if (submittedProgress == nval) {
        flight_status = 15;
      } else if (rejectedProgress == nval) {
        flight_status = 30;
      }
      this.queryTask(flight_status);
    },
    getStayPoints() {
      const taskPlanForm = this.$data.taskPlanForm;
      const station_id = taskPlanForm.station_id;
      this.getRequest(
        "/basic-info-server/taskPlan/queryStayPointList.do?station_id=" + station_id
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.$data.taskplanPointTableData = oData.data;
        } else if (oData.code != 401) {
          this.confirmMessage(false, "驻点获取失败~");
        }
      });
    },
    getHistoryAirLines() {
      const taskPlanForm = this.$data.taskPlanForm;
      const start_station_id = taskPlanForm.start_station_id;
      const end_station_id = taskPlanForm.end_station_id;
      this.getRequest(
        "/uav-task-server/airline/getAirLineList.do?pagesize=0&currentpage=1&start_station_id=" +
          start_station_id +
          "&end_station_id=" +
          end_station_id
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          const routePlanningTableData1 = (this.$data.routePlanningTableData1 =
            oData.data.list);
          if (!this.isEmptyArray(routePlanningTableData1)) {
            for (let index = 0; index < routePlanningTableData1.length; index++) {
              const element = routePlanningTableData1[index];
              try {
                if (!this.isEmptyStr(element.task_coordinate_waypoints)) {
                  const points = element.task_coordinate_waypoints.split(";");
                  element.point_count = points.length;
                }
              } catch (error) {}
            }
          }
        } else if (oData.code != 401) {
          this.confirmMessage(false, "驻点航线失败~");
        }
      });
    },
    checkQueryData(type) {
      const queryTimeInfo = this.$data.queryTimeInfo;
      if (
        queryTimeInfo &&
        queryTimeInfo[type] &&
        new Date().getTime() < queryTimeInfo[type] + 3000
      ) {
        return false;
      }
      return true;
    },
    formatterSecret(row, column, value) {
      const data = this.$data.goodsSecrecies[value];
      if (data) {
        return data[0] + data[1];
      }
      return "";
    },
    formatterLinkType(row, column, value) {
      if (this.$data.linkTypes[value]) {
        return this.$data.linkTypes[value].name;
      }
      return "";
    },
    confirmMessage(success, msg) {
      let tip = "<i class='el-icon-warn-tip'></i>";
      if (success) {
        tip = "<i class='el-icon-ok-tip'></i>";
        this.$message({
          message: "操作成功",
          duration: 1000,
          customClass: "message-s",
          iconClass: "el-icon-ok-tip",
          offset: 470,
          onClose: function () {},
        });
      } else {
        this.$confirm(tip + msg, "提示", {
          confirmButtonText: "好的",
          customClass: "confirmClass-style",
          iconClass: "",
          confirmButtonClass: "confirm",
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          cancelButtonClass: "cancel",
        });
      }
    }, // 查询任务
    /* 需求展示 */ queryTask(flight_status) {
      this.queryTaskForm.flight_status = flight_status;
      this.getRequest(
        "/uav-task-server/flight/queryFlightList.do?" +
          this.getQueryParam(this.queryTaskForm)
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          this.taskList = data.list;
        } else if (oData.code != 401) {
          this.confirmMessage(false, "任务列表获取失败~");
        }
      });
    },
    getQueryParam(form) {
      let param = "";
      if (form) {
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            const element = form[key];
            if (null !== element && undefined !== element && 0 < ("" + element).length) {
              param += "&" + key + "=" + element;
            }
          }
        }
      }
      return param;
    },
    queryTaskByCondition() {
      this.taskList = [];
      this.queryTaskForm.currentpage = 1;
      this.queryTaskPlan(this.currentProgress);
    },
    /* 需求展示 */
    changeParkingApron(val) {
      if (!this.$data.taskPlanForm.is_target) {
        delete this.$data.taskPlanForm.target_icon;
        this.$forceUpdate();
      }
    },
    selectParkingApron(type) {
      this.$set(this.$data.taskPlanForm, "target_icon", type);
    },
  },
  mounted() {
    this.queryTaskPlan(this.currentProgress);
    if (!window.queryTaskPlanTimer) {
      window.queryTaskPlanTimer = setInterval(this.queryTaskPlan, 30000); //30秒轮询一次
    }
  },
  watch: {
    activeAccordionName(nval, oval) {
      if (this.$data.designatedPersonnel === nval) {
        this.queryDepartment(); //查询部门信息
      } else if ("goodsPlan" === nval) {
        this.queryRemainGoods();
      } else if ("linkPlanning" === nval) {
        this.getAirLinkList();
      } else if ("taskplanPoint" === nval) {
        this.getStayPoints();
      } else if ("routePlanning" === nval) {
        const taskPlanForm = this.$data.taskPlanForm;
        const start_station_id = taskPlanForm.start_station_id;
        const end_station_id = taskPlanForm.end_station_id;
        if (null != start_station_id && null != end_station_id) {
          this.getHistoryAirLines();
        } else {
          this.$nextTick(function () {
            this.$set(this.$data, "activeAccordionName", "taskplanPoint");
          });
          this.confirmMessage(false, "请先选择驻点");
        }
      } else if (this.$data.uavSelect === nval) {
        const taskPlanForm = this.$data.taskPlanForm;
        const start_at = taskPlanForm.start_at;
        const end_at = taskPlanForm.end_at;
        if (null != start_at && null != end_at) {
          this.queryUavs();
        } else {
          this.$nextTick(function () {
            this.$set(this.$data, "activeAccordionName", "deliveryTime");
          });
          this.confirmMessage(false, "请先选择投送时间");
        }
      }
    },
    currentProgress(nval, oval) {
      if (newTaskProgress != nval) {
        this.$data.clickPlanRowFlag = false;
      }
      this.queryTaskPlan(nval);
    },
    "taskPlanForm.starstaypoint": function (nval, oval) {
      if (nval.altitude && -1 == (nval.altitude + "").indexOf("m")) {
        nval.altitude = nval.altitude + "m";
      }
    },
    "taskPlanForm.endstaypoint": function (nval, oval) {
      if (nval.altitude && -1 == (nval.altitude + "").indexOf("m")) {
        nval.altitude = nval.altitude + "m";
      }
    },
    "taskPlanForm.uav": function (nval, oval) {
      if (nval.max_payload && -1 == (nval.max_payload + "").indexOf("kg")) {
        nval.max_payload += "kg";
      }
      if (nval.max_fly_time && -1 == (nval.max_fly_time + "").indexOf("min")) {
        nval.max_fly_time += "min";
      }
      if (nval.uavmodel) {
        const uavmodel = nval.uavmodel;
        if (
          uavmodel.cargo_hold_volume &&
          -1 == (uavmodel.cargo_hold_volume + "").indexOf("cm3")
        ) {
          uavmodel.cargo_hold_volume += "cm3";
        }
      }
    },
  },
  computed: {
    deliveryTimeShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "deliveryTime"
      );
    },
    goodsPlanShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "goodsPlan"
      );
    },
    linkPlanningShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "linkPlanning"
      );
    },
    designatedPersonnelShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "designatedPersonnel"
      );
    },
    taskplanPointShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "taskplanPoint"
      );
    },
    routePlanningShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "routePlanning"
      );
    },
    uavSelectShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "uavSelect"
      );
    },
    planCirculationInfoShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "planCirculationInfo"
      );
    },
    noteTaskPlanShow() {
      return (
        (this.currentProgress == planningProgress ||
          this.currentProgress == submittedProgress) &&
        this.$data.activeAccordionName == "noteTaskPlan"
      );
    },
    newTaskProgressShow() {
      return this.currentProgress == "newTaskProgress";
    },
    planNeedDisplay() {
      return this.$data.clickPlanRowFlag;
    },
  },
  beforeDestroy() {
    if (window.queryTaskPlanTimer) {
      clearInterval(window.queryTaskPlanTimer);
      window.queryTaskPlanTimer = null;
    }
  },
};
</script>

<style scoped>
@import "../../../assets/css/home/TaskPlanning.css";
</style>

<style>
@import "../../../assets/css/home/TaskPlanningGlobal.css";
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/OtherTaskPlanning.vue